import {Block, Col, Row, Space, Typography} from "@bezlimit/bezlimit-ui";
import _ from "lodash";
import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import NumberFormat from "react-number-format";
import {LayoutContext} from "../../../core/Contexts";
import imgFiles from "../../../images/Pre-comp 2.gif";
import "./style.scss";
// forms
import FormOutputBonuses from "../../forms/outputOfBalanceBonuses";
// services
import BonusesService from "../../../services/BonusesService";

export default React.memo(function OutputOfBalanceBonuses() {
    const contextLayout = useContext(LayoutContext);
    const {t} = useTranslation();
    return (
        <Typography
            as="div"
            className="bl-replenishment-balanse-bonuses bl-replenishment-balanse-bonuses-output"
        >
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 24}
                direction="vertical"
                align="center"
            >
                <Typography as="div">
                    <Space size={16} direction="vertical" align="center">
                        <Typography
                            size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 17}
                            level={2}
                            color="#000000"
                        >
                            {t("Вывод бонусов")}
                        </Typography>
                        <Typography color="#828282" className="subtitle">
                            {" "}
                            {t("Вывод бонусов на баланс банковской карты")}{" "}
                        </Typography>
                        <Typography as="div" className="bl-bunner-payment">
                            <div className="vidContain">
                                <div
                                    className="pleer"
                                    dangerouslySetInnerHTML={{
                                        __html: `
                                            <video
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                        >
                                            <source src="bunner_payment.webm" type='video/webm; codecs="vp8, vorbis"' />
                                        </video>`
                                    }}
                                />
                                <Row gutter={[8, 8]} className="caption">
                                    <Col span={9}>
                                        <img
                                            src={imgFiles}
                                            alt=""
                                            width={_.gte(contextLayout?.width ?? 0, 768) ? 104 : 85}
                                            className="img-files"
                                        />
                                        <Typography className="title">{t("ВНИМАНИЕ")}</Typography>
                                    </Col>
                                    <Col span={15}>
                                        <Typography className="description">
                                            {t(
                                                "Вывести бонусы можно \nтолько на карту владельца \nПрофиля Store!"
                                            )}
                                        </Typography>
                                        <Typography className="sub-description">
                                            {t(
                                                "Платежи в пользу третьих лиц производиться не будут!"
                                            )}
                                        </Typography>
                                    </Col>
                                </Row>
                            </div>
                        </Typography>
                        <Block>
                            <Space direction="vertical">
                                <Typography size={12} fontFamily="hauss" color="#CFC8DB">
                                    {t("Бонусы доступные для списания")}
                                </Typography>
                                <Typography as="div" size={24} fontFamily="alumna">
                                    <NumberFormat
                                        className="format-accumulated-sum"
                                        thousandSeparator=" "
                                        displayType="text"
                                        value={BonusesService.accumulated.toFixed(2)}
                                    />
                                </Typography>
                            </Space>
                        </Block>
                    </Space>
                </Typography>
                <FormOutputBonuses />
            </Space>
        </Typography>
    );
});
